import { Spacing, Subhead } from '@vkontakte/vkui';
import discount from 'img/quota-landing/blackFriday2025/sale_small.png';
import React, { memo, useCallback } from 'react';
import { blackFriday2025Tariff } from 'reactApp/appHelpers/featuresHelpers/features/blackFriday2025';
import { multiTariffShowTabsMobile, periodSwitchShowWebviewOrTouch } from 'reactApp/appHelpers/featuresHelpers/features/multiTariffMobile';
import { getPaySource } from 'reactApp/modules/payment/payment.analytics';
import type { MobileBuyClickType } from 'reactApp/sections/MobileSubscriptionsPage/TariffCard/TariffCard.types';
import type { Product } from 'reactApp/types/Billing';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { useYearSaving } from 'reactApp/ui/TariffSectionNew/hooks/useYearSaving';
import { getPeriodName } from 'reactApp/utils/Period';
import { formatPrice, getMonthProductPrice } from 'reactApp/utils/priceHelpers';

import styles from './MultiTariffsListMobile.css';

interface Props {
    monthProduct: Product;
    yearProduct: Product;
    onBuy: MobileBuyClickType;
    blackFriday2025Enabled?: boolean;
}

export const BuyButtons = memo<Props>(({ yearProduct, monthProduct, onBuy, blackFriday2025Enabled }) => {
    const isYearTrial = yearProduct.hasTrial && Boolean(yearProduct?.trialPeriod);

    const [, yearSavingDiscount] = useYearSaving({
        monthProduct,
        yearProduct,
    });

    const onButtonClick = useCallback(
        (isYear) => {
            onBuy({
                selectedProduct: isYear ? yearProduct : monthProduct,
                yearProduct: isYear ? undefined : yearProduct,
                yearSavingDiscount: isYear ? undefined : yearSavingDiscount,
                paySource: getPaySource('tariff_card'),
            });
        },
        [yearProduct, monthProduct, yearSavingDiscount, onBuy]
    );
    return (
        <div className={styles.buttonBlock}>
            {!multiTariffShowTabsMobile && (
                <Button
                    primary
                    theme="vk"
                    sizeMode={ButtonSizeMode.extraBig}
                    onClick={() => onButtonClick(true)}
                    qaId="multitarif-button-year"
                >
                    <div>
                        <div data-qa-id="multitarif-button-text">
                            {isYearTrial ? 'Бесплатно' : `${formatPrice(getMonthProductPrice(yearProduct))} ₽ в месяц`}
                        </div>
                        <Subhead data-qa-id="multitarif-button-aadditional-text">
                            {isYearTrial ? `на ${getPeriodName(yearProduct.trialPeriod as string)}` : `при покупке на год`}
                        </Subhead>
                    </div>
                </Button>
            )}
            <Spacing size={12} />
            {periodSwitchShowWebviewOrTouch && (
                <Button
                    secondary
                    theme="vk"
                    sizeMode={ButtonSizeMode.extraBig}
                    onClick={() => onButtonClick(false)}
                    qaId="multitarif-button-month"
                >
                    <div data-qa-id="multitarif-button-text">{formatPrice(getMonthProductPrice(monthProduct))} ₽ в месяц</div>
                </Button>
            )}
            {yearSavingDiscount &&
                !isYearTrial &&
                !multiTariffShowTabsMobile &&
                !(blackFriday2025Enabled && yearProduct.id === blackFriday2025Tariff) && (
                    <div data-qa-id="multitarif-button-saving" className={styles.saving}>
                        -{yearSavingDiscount}%
                    </div>
                )}
            {blackFriday2025Enabled && yearProduct.id === blackFriday2025Tariff && (
                <img alt="-80%" src={discount} className={styles.savingBF} />
            )}
        </div>
    );
});

BuyButtons.displayName = 'BuyButtons';
